import {MinusOutlined, PlusOutlined} from '@ant-design/icons';
import {Form, Input} from 'antd';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import StoreActions from 'bukku/redux/Store/actions';
import styled from 'styled-components';

const Styled = styled.div`

    /* add padding to icon so the clickable area encloses the whole div */
    --icon-padding-x: 11px;
    --icon-padding-y: 8px;

    .large {
        --icon-padding-x: 11px;
        --icon-padding-y: 12px;
    }

    .small {
        --icon-padding-x: 6px;
        --icon-padding-y: 3.25px;
    }

    .input__quantity {
        width: ${props => props.width};

        .ant-input-wrapper.ant-input-group {
            .ant-input {
                text-align: center;    
            }
        }

        /* + and - icon */
        .ant-input-group-addon {
            padding: 0;

            &:hover,&:active {
                color: var(--neutralDark);
                cursor: pointer;
            }

            &:active {
                box-shadow: 0 0 5px var(--neutral);
            }

            transition: color 0.2s, box-shadow 0.1s ease-out;

            .icon__change-qty {
                padding: var(--icon-padding-y) var(--icon-padding-x);
            }
        }
    }
`;

const {
    addItemQty,
    subtractItemQty,
    setItemQty,
    addItemToCart,
} = StoreActions;

/**
 *
 * Props:
 * - width (int/String) : width of Input area. Optional, defaults to '100%'.
 * - size (String) : 'small', 'default', 'large'. Optional, defaults to 'default'.
 * - formRef (instance). Required.
 */
class QuantityInputCheckout extends Component {
    static defaultProps = {
        size: 'default',
    };

    roundOffAsInt = aVar => parseInt(Math.round(aVar), 10) || 1;

    onMinusQty = () => {
        const {
            subtractItemQty,
            formRef,
            product,
        } = this.props;

        const qty = this.roundOffAsInt(product.qty || 1); // Avoid NaN when user clears field or enter invalid

        // set Data
        subtractItemQty(product.productId, 1);
        // set Form UI
        formRef.current.setFieldsValue({
            [`productId_${product.productId}.qty`]: Math.max(qty - 1, 1), // Avoid qty smaller than 1
        });
    };

    onPlusQty = () => {
        const {
            addItemQty,
            formRef,
            product,
        } = this.props;
        //

        const qty = this.roundOffAsInt(product.qty || 1); // Avoid NaN when user clears field or enter invalid

        // set Data
        addItemQty(product.productId, 1);
        // set Form UI
        formRef.current.setFieldsValue({
            [`productId_${product.productId}.qty`]: qty + 1,
        });
    };

    onBlurQty = e => {
        const {
            setItemQty,
            formRef,
            product,
        } = this.props;

        const qty = this.roundOffAsInt(e.target.value);

        setItemQty(product.productId, qty);
        // set Form UI
        formRef.current.setFieldsValue({
            [`productId_${product.productId}.qty`]: qty,
        });
    };

    render() {
        const {
            width,
            size,
            product,
            ...restProps
        } = this.props;

        return (
            <Styled width={width} {...restProps}>
                <Form.Item
                    name={`productId_${product.productId}.qty`}
                    rules={[
                        { required: true, message: 'Please enter at least 1' },
                        { type: 'number', message: 'Please enter a number' },
                    ]}
                    noStyle
                    initialValue={product.qty}
                >
                    <Input
                        className="input__quantity"
                        size={size}
                        addonBefore={<MinusOutlined
                            className={`icon__change-qty ${size}`}
                            onClick={this.onMinusQty}
                        />}
                        addonAfter={<PlusOutlined
                            className={`icon__change-qty ${size}`}
                            onClick={this.onPlusQty}
                        />}
                        onBlur={this.onBlurQty}
                        // defaultValue={product.qty}
                    />
                </Form.Item>
            </Styled>
        );
    }
}

export default connect(() => ({

}),
{
    addItemQty,
    subtractItemQty,
    setItemQty,
    addItemToCart,
})(QuantityInputCheckout);
